module.exports = __webpack_public_path__ + "img/sort.a6a09277.svg";